// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"188":"949d6d3d","856":"4fd4fbde"}[chunkId] + ".js";
};